<ideal-product-fees-view [pricing]="pricing()" [multiplyBy]="multiplyBy()" />
